import { update } from 'lodash'
import { FULL_RESET_EVENT, UPDATE_EVENT } from './actions'
import { IHubEventBasicFormState } from './contracts'

export const EVENT_BASIC_FORM_STATE: IHubEventBasicFormState = {
  id: undefined,
  name: '',
  startDate: '',
  startTime: '',
  address: {
    id: '',
    name: '',
    addressZipCode: '',
    addressLineOne: '',
    addressLineTwo: '',
    addressNumber: '',
    addressNeighborhood: '',
    addressCity: '',
    addressState: ''
  },
  files: [],
  style: {
    path: ''
  },
  endDate: '',
  endTime: '',
  ticketDescription: '',
  website: '',
  description: '',
  isLaunched: false,
  isPaid: false,
  isActive: true,
  isInPerson: true
}

export interface IHubEventBasicFormStepConfigStateAction {
  type: string
  payload: IHubEventBasicFormState
}

export const HubEventBasicFormReducer = (
  state: IHubEventBasicFormState = EVENT_BASIC_FORM_STATE,
  action: IHubEventBasicFormStepConfigStateAction
): any => {
  switch (action.type) {
    case FULL_RESET_EVENT:
      return {
        ...EVENT_BASIC_FORM_STATE,
        id: undefined,
        name: '',
        startDate: null,
        startTime: null,
        endDate: '',
        endTime: '',
        ticketDescription: '',
        website: '',
        description: '',
        isLaunched: false,
        isPaid: false,
        isActive: true,
        isInPerson: true,
        files: [],
        style: {},
        address: {}
      }

    case UPDATE_EVENT:
      return {
        ...state,
        id: action.payload.id,
        name: action.payload.name,
        startDate: action.payload.startDate,
        startTime: action.payload.startTime,
        endDate: action.payload.endDate,
        endTime: action.payload.endTime,
        ticketDescription: action.payload.ticketDescription,
        website: action.payload.website,
        description: action.payload.description,
        isLaunched: action.payload.isLaunched,
        isPaid: action.payload.isPaid,
        isActive: action.payload.isActive,
        isInPerson: action.payload.isInPerson,
        files: action.payload.files,
        style: action.payload.style,
        address: action.payload.address
      }

    default:
      return state
  }
}
